import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Rating,
  TextField,
  Typography,
} from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";

import Navbar from "../../components/Page Component/Navbar";
import Footer from "../../components/Page Component/Footer";
import {
  editEmployeeSelfResponse,
  finalSubmit,
  getResponseId,
  viewEmployeeSelfResponse,
} from "../../Service/Apis";
import useAxiosInterceptor from "../../components/layout/AxiosInstance";

import { enqueueSnackbar } from "notistack";
import { labels } from "../Dashboard/ReviewForm";
import { setResponseId } from "../../store/FormSlice";
import { setInPageLoading, setIsLoading } from "../../store/LoadingSlice";
import Skeletons from "../../components/Skeleton/Skeletons";
import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";
import {
  FetchDataFailureAction,
  FetchDataSuccessAction,
  fetchData,
  patchData,
  postData,
  putData,
} from "../../store/actions";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { RootState } from "../../store/Store";
import { postDataSuccess } from "../../store/AxiosSlice";
import Loading from "../../components/Loading/Loading";

interface ResponseType {
  response_id: string;
  form_team_id: string;
  form_id: string;
  form_name: string;
  form_description: string;
  team_id: string;
  project_name: string;
  manager: string;
  employee_id: string;
  roles: string[];
  employee_name: string;
  employee_deadline: string;
  manager_deadline: string;
  is_appraisal: boolean;
  is_hierarchical: boolean;
  response: Section[]; // Update this to use Section[] instead of [{...}]
}

interface Response1 {
  section_id: string;
  category_id: string;
  question_id: string;
  employee_response: string;
  employee_comment: string;
  employee_rating: string;
}

interface Section {
  section_id: string;
  section: string;
  categories: Category[];
}

interface Category {
  category_id: string;
  category: string;
  questions: Question[];
}

interface Question {
  question_id: string;
  question_name: string;
  employee_rating: string;
  employee_response: string;
  employee_comment: string;
  answer_type: string;
  answer_choices: {
    option_id: string;
    answer_value: string;
  }[];
}

interface SpecialCharErrors {
  [sectionIndex: number]: {
    [categoryIndex: number]: {
      [questionIndex: number]: {
        employee_response: boolean;
        employee_comment: boolean;
      };
    };
  };
}

interface MinCharacterError {
  [sectionIndex: number]: {
    [categoryIndex: number]: {
      [questionIndex: number]: {
        employee_response: boolean;
        employee_comment: boolean;
      };
    };
  };
}

interface SpacesErrors {
  [sectionIndex: number]: {
    [categoryIndex: number]: {
      [questionIndex: number]: {
        employee_response: boolean;
        employee_comment: boolean;
      };
    };
  };
}

interface HoverEffect {
  [sectionIndex: number]: {
    [categoryIndex: number]: {
      [questionIndex: number]: {
        employee_rating: number;
      };
    };
  };
}
const initialSpecialCharErrors: SpecialCharErrors = {};
const initialMinCharacterErrors: MinCharacterError = {};
const initialSpacesErrors: SpacesErrors = {};
const initialHoverEffect: HoverEffect = {};

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .00)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const ShowResponseAppraisalForm = () => {
  const [viewResponse, setViewResponse] = useState<ResponseType[]>([]);
  const [specialCharErrors, setSpecialCharErrors] = useState<SpecialCharErrors>(
    initialSpecialCharErrors
  );
  const [hoverEffect, setHoverEffect] =
    useState<HoverEffect>(initialHoverEffect);

  const [spacesErrors, setSpacesErrors] =
    useState<SpacesErrors>(initialSpacesErrors);
  const [minCharacterError, setMinCharacterError] = useState<MinCharacterError>(
    initialMinCharacterErrors
  );
  const [flag, setFlag] = useState<boolean>(false);
  const [flag2, setFlag2] = useState<boolean>(false);
  const [empRating, setEmpRating] = useState<boolean[][][]>([]);
  const [isSpecialCharError, setIsSpecialCharError] = useState<boolean>(false);
  const [isSpacesError, setIsSpacesError] = useState<boolean>(false);
  const [isMinCharacterError, setIsMinCharacterError] =
    useState<boolean>(false);
  const [value, setValue] = useState<number | null>(0);
  const axiosInstance = useAxiosInterceptor();
  const showToast = useCustomToast();

  const Navigate = useNavigate();

  const dispatch2: ThunkDispatch<
    RootState,
    null,
    FetchDataSuccessAction | FetchDataFailureAction
  > = useDispatch();

  // const success = useSelector((state: any) => state.http.data);

  const formId =
    useSelector((state: any) => state.form.formTeamId) ||
    localStorage.getItem("formTeamId");

  const formTeamId =
    useSelector((state: any) => state.form.formTeamId) ||
    localStorage.getItem("formTeamId");

  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };

  const token = localStorage.getItem("token");
  // const Navigate=useNavigate();
  const responseId = useSelector((state: any) => state.form.response_id);

  const dispatch = useDispatch();
  dispatch(setIsLoading(false));

  const employeeCode =
    useSelector((state: any) => state.person.perstate.employee_code) ||
    localStorage.getItem("employee_code");

  const designation =
    useSelector((state: any) => state.person.perstate.designation) ||
    localStorage.getItem("designation");

  const isLoading = useSelector((state: any) => state.loading.isLoading);
  const inPageLoading = useSelector(
    (state: any) => state.loading.inPageLoading
  );

  const hasSpecialCharacters = (input: string): boolean => {
    const specialCharacterPattern = /[#^*_+\=\;:"\\|<>/]/;
    return specialCharacterPattern.test(input);
  };

  const handleChange = (
    sectionIndex: number,
    categoryIndex: number,
    questionIndex: number,
    section_id: string,
    category_id: string,
    question_id: string,
    field: keyof Question,
    value: string,
    answer_type: string
  ): void => {
    const containsOnlySpaces = /^\s*$/.test(value);

    setViewResponse((prevResponse) => {
      // Create a new copy of the response array to update it
      const updatedResponse: ResponseType[] = prevResponse.map(
        (item, itemIndex) => {
          if (itemIndex === 0) {
            // Update only the first element (index 0) of the array
            const updatedSections: Section[] = item.response.map(
              (section, sIndex) => {
                if (sIndex === sectionIndex) {
                  // Update the specific section
                  const updatedCategories: Category[] = section.categories.map(
                    (category, cIndex) => {
                      if (cIndex === categoryIndex) {
                        // Update the specific category
                        const updatedQuestions: Question[] =
                          category.questions.map((question, qIndex) => {
                            if (qIndex === questionIndex) {
                              // Update the specific question
                              return {
                                ...question,
                                [field]: value ? value : "",
                                question_id,
                              };
                            }
                            return question;
                          });

                        return {
                          ...category,
                          category_id,
                          questions: updatedQuestions,
                        };
                      }
                      return category;
                    }
                  );

                  return {
                    ...section,
                    section_id,
                    categories: updatedCategories,
                  };
                }
                return section;
              }
            );

            return {
              ...item,
              response: updatedSections,
            };
          }

          // For other elements (if any), keep them unchanged
          return item;
        }
      );

      return updatedResponse;
    });

    const updatedSpecialCharErrors = { ...specialCharErrors };
    const sectionErrors = updatedSpecialCharErrors[sectionIndex] || {};
    const categoryErrors = sectionErrors[categoryIndex] || {};
    const questionErrors = categoryErrors[questionIndex] || {
      employee_response: false,
      employee_comment: false,
    };

    const updatedSpacesErrors = { ...spacesErrors };
    const sectionSpacesErrors = updatedSpacesErrors[sectionIndex] || {};
    const categorySpacesErrors = sectionSpacesErrors[categoryIndex] || {};
    const questionSpacesErrors = categorySpacesErrors[questionIndex] || {
      employee_response: false,
    };

    const updatedMinCharacterError = { ...minCharacterError };
    const sectionMinCharatcerError =
      updatedMinCharacterError[sectionIndex] || {};
    const categoryMinCharacterErorr =
      sectionMinCharatcerError[categoryIndex] || {};
    const questionMinCharacterError = categoryMinCharacterErorr[
      questionIndex
    ] || {
      // employee_comment: false,
      employee_response: false,
    };

    // Check for special characters in employee_response and employee_comment
    if (field === "employee_response") {
      if (answer_type === "short_answer") {
        questionErrors.employee_response = hasSpecialCharacters(value);
      }
      questionSpacesErrors.employee_response = containsOnlySpaces;
      if (answer_type === "short_answer") {
        questionMinCharacterError.employee_response = value.length < 3;
      }
    } else if (field === "employee_comment") {
      questionErrors.employee_comment = hasSpecialCharacters(value);
      // questionMinCharacterError.employee_comment = value.length < 3;
    }

    // Update the specialCharErrors state
    categoryErrors[questionIndex] = questionErrors;
    sectionErrors[categoryIndex] = categoryErrors;
    updatedSpecialCharErrors[sectionIndex] = sectionErrors;

    setSpecialCharErrors(updatedSpecialCharErrors);

    categorySpacesErrors[questionIndex] = questionSpacesErrors;
    sectionSpacesErrors[categoryIndex] = categorySpacesErrors;
    updatedSpacesErrors[sectionIndex] = sectionSpacesErrors;

    setSpacesErrors(updatedSpacesErrors);

    categoryMinCharacterErorr[questionIndex] = questionMinCharacterError;
    sectionMinCharatcerError[categoryIndex] = categoryMinCharacterErorr;
    updatedMinCharacterError[sectionIndex] = sectionMinCharatcerError;

    setMinCharacterError(updatedMinCharacterError);

    // Check for any Special Character Error.
    let isAnySpecialCharError = false;
    Object.values(updatedSpecialCharErrors).forEach((categories) => {
      Object.values(categories).forEach((questions) => {
        Object.values(questions).forEach((error) => {
          if (error.employee_response || error.employee_comment) {
            isAnySpecialCharError = true;
          }
        });
      });
    });

    // Check for any Spaces Error.
    let isAnySpacesError = false;
    Object.values(updatedSpacesErrors).forEach((categories) => {
      Object.values(categories).forEach((questions) => {
        Object.values(questions).forEach((error) => {
          if (error.employee_response) {
            isAnySpacesError = true;
          }
        });
      });
    });

    // Check for any Minimum Character Errors.
    let isMinCharacterErrors = false;
    Object.values(updatedMinCharacterError).forEach((categories) => {
      Object.values(categories).forEach((questions) => {
        Object.values(questions).forEach((error) => {
          if (error.employee_response) {
            isMinCharacterErrors = true;
          }
        });
      });
    });
    // setIsMinCharacterError(isMinCharacterErrors);
    // setIsSpacesError(isAnySpacesError);
    setIsSpecialCharError(isAnySpecialCharError);
  };

  // Check for spaces errors.
  const validateSpacesError = () => {
    const containsOnlySpaces = /^\s*$/;
    viewResponse[0].response.forEach((section, sectionIndex) => {
      section.categories.forEach((category, categoryIndex) => {
        category.questions.forEach((question, questionIndex) => {
          const { employee_response, employee_comment } = question;

          if (
            (employee_response && employee_response.trim().length === 0) ||
            containsOnlySpaces.test(employee_response)
          ) {
            if (!spacesErrors[sectionIndex]) {
              spacesErrors[sectionIndex] = {};
            }
            if (!spacesErrors[sectionIndex][categoryIndex]) {
              spacesErrors[sectionIndex][categoryIndex] = {};
            }
            spacesErrors[sectionIndex][categoryIndex][questionIndex] = {
              employee_response: true,
              employee_comment: false,
            };
            setIsSpacesError(true);
          }
        });
      });
    });
  };

  // check for minimum character error.
  const validateMinCharacters = () => {
    viewResponse[0].response.forEach((section, sectionIndex) => {
      section.categories.forEach((category, categoryIndex) => {
        category.questions.forEach((question, questionIndex) => {
          const { employee_response, employee_comment, answer_type } = question;

          if (
            employee_response &&
            employee_response.trim().length < 3 &&
            answer_type === "short_answer"
          ) {
            if (!minCharacterError[sectionIndex]) {
              minCharacterError[sectionIndex] = {};
            }
            if (!minCharacterError[sectionIndex][categoryIndex]) {
              minCharacterError[sectionIndex][categoryIndex] = {};
            }
            minCharacterError[sectionIndex][categoryIndex][questionIndex] = {
              employee_response: true,
              employee_comment: false,
            };
            setIsMinCharacterError(true);
          }
        });
      });
    });
  };

  // Initialise the rating as false.
  const initializeEmpRatingState = (response: ResponseType) => {
    const empRatingArray: boolean[][][] = [];

    response?.response?.forEach((section, sectionIndex) => {
      const sectionEmpRating: boolean[][] = [];

      section?.categories?.forEach((category, categoryIndex) => {
        const categoryEmpRating: boolean[] = [];

        category?.questions?.forEach((question) => {
          const hasEmployeeRating =
            question?.hasOwnProperty("employee_rating") &&
            question.employee_rating !== null &&
            question.employee_rating !== "";
          categoryEmpRating.push(hasEmployeeRating);
        });

        sectionEmpRating.push(categoryEmpRating);
      });

      empRatingArray.push(sectionEmpRating);
    });

    setEmpRating(empRatingArray);
  };

  const handleSubmit = async (e: any, form_team_id: string) => {
    e.preventDefault();

    validateMinCharacters();
    validateSpacesError();

    const isEveryEmpRatingTrue = empRating.every((section) => {
      return section.every((category) => {
        return category.every((questionEmpRating) => {
          return questionEmpRating === true;
        });
      });
    });

    let isMinCharacterErrors = false;

    Object.values(minCharacterError).forEach((categories) => {
      Object.values(categories).forEach((questions: any) => {
        Object.values(questions).forEach((error: any) => {
          if (error.employee_response) {
            isMinCharacterErrors = true;
          }
        });
      });
    });

    let isSpacesError = false;

    Object.values(spacesErrors).forEach((categories) => {
      Object.values(categories).forEach((questions: any) => {
        Object.values(questions).forEach((error: any) => {
          if (error.employee_response) {
            isSpacesError = true;
          }
        });
      });
    });

    // Now you can use isEveryEmpRatingTrue to conditionally render content or take any other action based on the empRating state.
    if (!isEveryEmpRatingTrue || isSpacesError || isMinCharacterErrors) {
      setFlag(true);
      setFlag2(true);

      handleShowToast("Please fill all details", "error", true);
      return;
    }
    handleSave(e);

    // API call to submit the form.
    try {
      const response = await dispatch2(
        patchData(`${finalSubmit}${viewResponse[0]?.response_id}`, {})
      )
        .then((response) => {
          dispatch(setInPageLoading(true));
          handleShowToast("Form Submitted Successfully !", "success", true);
          dispatch(postDataSuccess(null));
          dispatch(setInPageLoading(false));
          Navigate("/dashboard");
        })
        .catch((error) => {
          console.log(error);
          dispatch(setInPageLoading(false));
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSave = async (e: any) => {
    e.preventDefault();
    dispatch(setInPageLoading(true));
    const isEveryEmpRatingTrue = empRating.every((section) => {
      return section.every((category) => {
        return category.every((questionEmpRating) => {
          return questionEmpRating === true;
        });
      });
    });

    // Convert the data into the specific format that goes to API.
    const responseToArray = (response: ResponseType): Response1[] => {
      const responseArray: Response1[] = [];

      response.response.forEach((section) => {
        if (section) {
          const { section_id } = section;

          section.categories.forEach((category) => {
            if (category) {
              const { category_id } = category;

              category.questions.forEach((question) => {
                if (question) {
                  const {
                    question_id,
                    employee_response,
                    employee_comment,
                    employee_rating,
                  } = question;

                  const response1: Response1 = {
                    section_id,
                    category_id,
                    question_id,
                    employee_response: employee_response,
                    employee_comment:
                      employee_comment !== undefined ? employee_comment : "",
                    employee_rating: employee_rating,
                  };
                  responseArray.push(response1);
                }
              });
            }
          });
        }
      });

      return responseArray;
    };

    const data = responseToArray(viewResponse[0]);

    const response_id = viewResponse[0]?.response_id;

    // API call to update  the form response.
    try {
      const response = await dispatch2(
        patchData(`${editEmployeeSelfResponse}${response_id}`, data)
      )
        .then((response) => {
          handleShowToast("Updated Successfully!", "success", false);
          dispatch(postDataSuccess(null));
          Navigate("/dashboard");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    dispatch(setInPageLoading(false));
  };

  // API call to view specific response of the employee.
  useEffect(() => {
    const fetchEmployeeSelfResponse = async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await dispatch2(
          fetchData(`${viewEmployeeSelfResponse}${formId}`)
        );
        setViewResponse(response as ResponseType[]);
        dispatch(setIsLoading(false));
      } catch (error) {
        console.log(error);
        dispatch(setIsLoading(false));
      }
    };
    fetchEmployeeSelfResponse();
  }, []);

  useEffect(() => {
    initializeEmpRatingState(viewResponse[0]);
  }, [viewResponse]);

  // Get the response id to update the response.
  useEffect(() => {
    const fetchResponseId = async () => {
      try {
        const response = await dispatch2(
          fetchData(`${getResponseId}${formTeamId}`)
        );
        dispatch(setResponseId(response as any));
      } catch (error) {
        console.log(error);
      }
    };
    fetchResponseId();
  }, []);

  if (inPageLoading) {
    return (
      <>
        <Loading isLoading={inPageLoading as boolean} />
      </>
    );
  }

  if (isLoading) {
    return (
      <>
        <Loading isLoading={isLoading as boolean} />
      </>
    );
  }

  return (
    <>
      <Box sx={{ mt: 12, mb: 10, display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "75%" }}>
          {viewResponse?.map((res) => {
            return (
              <Box
                key={res.form_id}
                component="form"
                onSubmit={(e) => {
                  handleSubmit(e, res.form_team_id);
                }}
              >
                <FormControl>
                  <Box
                    sx={{
                      mt: 1,
                      pt: 2,
                      display: "flex",
                      justifyContent: "center",
                      width: "100% ",
                    }}
                  >
                    <Typography
                      fontWeight={"bold"}
                      letterSpacing={3}
                      variant="h4"
                      sx={{ textDecoration: "underline" }}
                      id="form_name"
                    >
                      {res.form_name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      m: 1,
                      mt: 2,
                      mb: 3,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h5" id="form_description">
                      {res.form_description
                        ? `(${res.form_description})`
                        : "(No description)"}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      m: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                        <Typography
                          sx={{ width: "9rem" }}
                          fontWeight={"bold"}
                          id="appraisee_name"
                        >
                          Appraisee :
                        </Typography>
                        <Typography>{res.employee_name} </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                        <Typography
                          sx={{ width: "9rem" }}
                          fontWeight={"bold"}
                          id="manager_name"
                        >
                          Manager Name :{" "}
                        </Typography>
                        <Typography>{res.manager}</Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                        <Typography
                          sx={{ width: "9rem" }}
                          fontWeight={"bold"}
                          id="employee_code"
                        >
                          Employee Code :{" "}
                        </Typography>
                        <Typography>{employeeCode} </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                        <Typography
                          sx={{ width: "9rem" }}
                          fontWeight={"bold"}
                          id="designation"
                        >
                          Designation :{" "}
                        </Typography>
                        <Typography>{designation}</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Divider />
                  {/* <Box sx={{ display: "flex", justifyContent: "right", m: 2 }}>
                    <Button
                      type="submit"
                      
                      size="large"
                      // variant="contained"
                    //   disabled={edit}
                      onClick={() => {
                        setEdit(!edit);
                      }}
                    >
                      Edit
                    </Button>
                  </Box> */}
                  <Box sx={{}}>
                    {res.response.map((section, sectionIndex) => {
                      return (
                        <Box sx={{ m: 2, width: "75vw" }}>
                          <Accordion
                            sx={{
                              m: 2,
                              p: 0,
                              width: "100%",
                              backgroundColor: "white",
                            }}
                          >
                            <AccordionSummary>
                              <Box>
                                <Typography
                                  variant="h5"
                                  fontWeight={"bold"}
                                  id={`section_${sectionIndex + 1}`}
                                >
                                  {String.fromCharCode(
                                    sectionIndex + "A".charCodeAt(0)
                                  ) +
                                    ") " +
                                    section.section}
                                </Typography>
                              </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box sx={{ m: 2, p: 2 }}>
                                {section.categories.map(
                                  (category, categoryIndex) => {
                                    return (
                                      <Box>
                                        <Box>
                                          <Typography
                                            variant="h5"
                                            fontWeight={"bold"}
                                            id={`section_${
                                              sectionIndex + 1
                                            }_category_${categoryIndex + 1}`}
                                          >
                                            {String.fromCharCode(
                                              categoryIndex + "a".charCodeAt(0)
                                            ) +
                                              ". " +
                                              category.category}
                                          </Typography>
                                        </Box>
                                        <Box sx={{ m: 2, p: 2 }}>
                                          {category.questions.map(
                                            (question, questionIndex) => {
                                              return (
                                                <Box key={question.question_id}>
                                                  <Box>
                                                    <Typography
                                                      fontWeight={"bold"}
                                                      fontSize={19}
                                                      variant="h6"
                                                      id={`section_${
                                                        sectionIndex + 1
                                                      }_category_${
                                                        categoryIndex + 1
                                                      }_question_${
                                                        questionIndex + 1
                                                      }`}
                                                    >
                                                      {questionIndex + 1 + "."}{" "}
                                                      {question.question_name}
                                                    </Typography>
                                                  </Box>
                                                  <Box sx={{ ml: 2, mr: 2 }}>
                                                    {question.answer_type ===
                                                    "short_answer" ? (
                                                      <Box>
                                                        <TextField
                                                          id={`employee_response_section_${
                                                            sectionIndex + 1
                                                          }_category__${
                                                            categoryIndex + 1
                                                          }_question_${
                                                            questionIndex + 1
                                                          }`}
                                                          required
                                                          name={`descriptive_${questionIndex}`}
                                                          size="small"
                                                          // minRows={4}

                                                          fullWidth
                                                          multiline
                                                          //   InputProps={{
                                                          //     readOnly: !edit,
                                                          //   }}
                                                          // rows={1}
                                                          sx={{
                                                            m: 2,
                                                            overflow: "auto",
                                                          }}
                                                          // disabled
                                                          maxRows={4}
                                                          value={
                                                            question.employee_response
                                                          }
                                                          style={{
                                                            height: "auto",
                                                          }}
                                                          InputProps={{
                                                            style: {
                                                              minHeight:
                                                                "unset",
                                                            },
                                                          }}
                                                          onChange={(e) => {
                                                            handleChange(
                                                              sectionIndex,
                                                              categoryIndex,
                                                              questionIndex,
                                                              section.section_id,
                                                              category.category_id,
                                                              question.question_id,
                                                              "employee_response",
                                                              e.target.value,
                                                              question.answer_type
                                                            );
                                                          }}
                                                          helperText={
                                                            <>
                                                              {specialCharErrors[
                                                                sectionIndex
                                                              ]?.[
                                                                categoryIndex
                                                              ]?.[questionIndex]
                                                                ?.employee_response && (
                                                                <Typography
                                                                  color={
                                                                    "error"
                                                                  }
                                                                >
                                                                  Special
                                                                  Characters not
                                                                  allowed.
                                                                </Typography>
                                                              )}
                                                              {spacesErrors[
                                                                sectionIndex
                                                              ]?.[
                                                                categoryIndex
                                                              ]?.[questionIndex]
                                                                ?.employee_response &&
                                                                flag && (
                                                                  <Typography
                                                                    color={
                                                                      "error"
                                                                    }
                                                                  >
                                                                    Only Spaces
                                                                    not allowed.
                                                                  </Typography>
                                                                )}
                                                              {minCharacterError[
                                                                sectionIndex
                                                              ]?.[
                                                                categoryIndex
                                                              ]?.[questionIndex]
                                                                ?.employee_response &&
                                                                flag2 && (
                                                                  <Typography
                                                                    color={
                                                                      "error"
                                                                    }
                                                                  >
                                                                    Minimum 3
                                                                    characters
                                                                    required.
                                                                  </Typography>
                                                                )}
                                                            </>
                                                          }
                                                        />
                                                      </Box>
                                                    ) : (
                                                      <Box>
                                                        <Box
                                                          sx={{
                                                            display: "block",
                                                            alignItems:
                                                              "center",
                                                            m: 1,
                                                          }}
                                                        >
                                                          <RadioGroup
                                                            id={`employee_response_section_${
                                                              sectionIndex + 1
                                                            }_category__${
                                                              categoryIndex + 1
                                                            }_question_${
                                                              questionIndex + 1
                                                            }`}
                                                            name={`choices_${questionIndex}`}
                                                            value={
                                                              question.employee_response
                                                            }
                                                            onChange={(e) => {
                                                              handleChange(
                                                                sectionIndex,
                                                                categoryIndex,
                                                                questionIndex,
                                                                section.section_id,
                                                                category.category_id,
                                                                question.question_id,
                                                                "employee_response",
                                                                e.target.value,
                                                                question.answer_type
                                                              );
                                                            }}
                                                          >
                                                            {question.answer_choices &&
                                                              question.answer_choices.map(
                                                                (
                                                                  ans: any,
                                                                  answerValueIndex: number
                                                                ) => (
                                                                  <FormControlLabel
                                                                    id={`employee_response_section_${
                                                                      sectionIndex +
                                                                      1
                                                                    }_category__${
                                                                      categoryIndex +
                                                                      1
                                                                    }_question_${
                                                                      questionIndex +
                                                                      1
                                                                    }_answer_value_${
                                                                      answerValueIndex +
                                                                      1
                                                                    }`}
                                                                    required
                                                                    // disabled={
                                                                    //   !edit
                                                                    // }
                                                                    key={
                                                                      ans.option_id
                                                                    }
                                                                    value={
                                                                      ans.answer_value
                                                                    }
                                                                    control={
                                                                      <Radio
                                                                        id={`employee_response_section_${
                                                                          sectionIndex +
                                                                          1
                                                                        }_category__${
                                                                          categoryIndex +
                                                                          1
                                                                        }_question_${
                                                                          questionIndex +
                                                                          1
                                                                        }_answer_value_${
                                                                          answerValueIndex +
                                                                          1
                                                                        }_radio_button`}

                                                                        //   value={
                                                                        //     ans.answer_value
                                                                        //   }
                                                                      />
                                                                    }
                                                                    label={
                                                                      ans.answer_value
                                                                    }
                                                                  />
                                                                )
                                                              )}
                                                            {/* <Divider
                                                          sx={{
                                                            // color: "green",
                                                            height: "1px",
                                                            // backgroundColor: "green",
                                                          }}
                                                        /> */}
                                                          </RadioGroup>
                                                        </Box>
                                                        <Box
                                                          sx={{
                                                            display: "flex",
                                                            m: 1,
                                                            p: 1,
                                                          }}
                                                        >
                                                          <Typography
                                                            fontWeight={"bold"}
                                                            paragraph
                                                            sx={{
                                                              width: "11rem",
                                                            }}
                                                          >
                                                            Comments :{" "}
                                                          </Typography>
                                                          <TextField
                                                            id={`employee_comment_section_${
                                                              sectionIndex + 1
                                                            }_category__${
                                                              categoryIndex + 1
                                                            }_question_${
                                                              questionIndex + 1
                                                            }`}
                                                            name="employee_comment"
                                                            fullWidth
                                                            multiline
                                                            // rows={2}
                                                            // InputProps={{
                                                            //   readOnly: !edit,
                                                            // }}
                                                            maxRows={4}
                                                            style={{
                                                              height: "auto",
                                                              overflow: "auto",
                                                            }}
                                                            value={
                                                              question.employee_comment
                                                            }
                                                            onChange={(e) => {
                                                              handleChange(
                                                                sectionIndex,
                                                                categoryIndex,
                                                                questionIndex,
                                                                section.section_id,
                                                                category.category_id,
                                                                question.question_id,
                                                                "employee_comment",
                                                                e.target.value,
                                                                question.answer_type
                                                              );
                                                            }}
                                                            helperText={
                                                              <>
                                                                {specialCharErrors[
                                                                  sectionIndex
                                                                ]?.[
                                                                  categoryIndex
                                                                ]?.[
                                                                  questionIndex
                                                                ]
                                                                  ?.employee_comment && (
                                                                  <Typography
                                                                    color={
                                                                      "error"
                                                                    }
                                                                  >
                                                                    Special
                                                                    Characters
                                                                    not allowed.
                                                                  </Typography>
                                                                )}
                                                                {minCharacterError[
                                                                  sectionIndex
                                                                ]?.[
                                                                  categoryIndex
                                                                ]?.[
                                                                  questionIndex
                                                                ]
                                                                  ?.employee_comment && (
                                                                  <Typography
                                                                    color={
                                                                      "error"
                                                                    }
                                                                  >
                                                                    Minimum 3
                                                                    characters
                                                                    required.
                                                                  </Typography>
                                                                )}
                                                              </>
                                                            }
                                                          />
                                                        </Box>
                                                      </Box>
                                                    )}
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        m: 1,
                                                        p: 1,
                                                      }}
                                                    >
                                                      <Typography
                                                        fontWeight={"bold"}
                                                        paragraph
                                                        sx={{
                                                          width: "8.5rem",
                                                          mt: 0.5,
                                                        }}
                                                      >
                                                        Rating :{" "}
                                                      </Typography>
                                                      <Rating
                                                        id={`employee_rating_section_${
                                                          sectionIndex + 1
                                                        }_category__${
                                                          categoryIndex + 1
                                                        }_question_${
                                                          questionIndex + 1
                                                        }`}
                                                        size="large"
                                                        precision={0.5}
                                                        // readOnly={!edit}
                                                        onChange={(
                                                          e,
                                                          newValue
                                                        ) => {
                                                          handleChange(
                                                            sectionIndex,
                                                            categoryIndex,
                                                            questionIndex,
                                                            section.section_id,
                                                            category.category_id,
                                                            question.question_id,
                                                            "employee_rating",
                                                            newValue?.toString() ||
                                                              "",
                                                            question.answer_type
                                                          );
                                                        }}
                                                        onChangeActive={(
                                                          event,
                                                          newHover
                                                        ) => {
                                                          // Update the hoverEffect state when the user hovers over the question
                                                          setHoverEffect(
                                                            (
                                                              prevHoverEffect
                                                            ) => {
                                                              const updatedHoverEffect =
                                                                {
                                                                  ...prevHoverEffect,
                                                                };
                                                              // Ensure that the nested objects are initialized properly
                                                              updatedHoverEffect[
                                                                sectionIndex
                                                              ] =
                                                                updatedHoverEffect[
                                                                  sectionIndex
                                                                ] || {};
                                                              updatedHoverEffect[
                                                                sectionIndex
                                                              ][categoryIndex] =
                                                                updatedHoverEffect[
                                                                  sectionIndex
                                                                ][
                                                                  categoryIndex
                                                                ] || {};
                                                              // Set the employee_rating value for the corresponding question
                                                              updatedHoverEffect[
                                                                sectionIndex
                                                              ][categoryIndex][
                                                                questionIndex
                                                              ] = {
                                                                employee_rating:
                                                                  newHover,
                                                              };
                                                              return updatedHoverEffect;
                                                            }
                                                          );
                                                        }}
                                                        value={parseFloat(
                                                          question.employee_rating
                                                        )}
                                                        className="rating-color"
                                                        aria-required="true"
                                                      />
                                                      {!(
                                                        viewResponse[0]
                                                          ?.response[
                                                          sectionIndex
                                                        ]?.categories[
                                                          categoryIndex
                                                        ]?.questions[
                                                          questionIndex
                                                        ]?.employee_rating !==
                                                        null
                                                      ) &&
                                                        flag && (
                                                          <Typography
                                                            sx={{ m: 0.5 }}
                                                            color={"error"}
                                                          >
                                                            This field is
                                                            required.
                                                          </Typography>
                                                        )}
                                                      {viewResponse[0]
                                                        ?.response[sectionIndex]
                                                        ?.categories[
                                                        categoryIndex
                                                      ]?.questions[
                                                        questionIndex
                                                      ]?.employee_rating ===
                                                        "" &&
                                                        flag && (
                                                          <Typography
                                                            sx={{ m: 0.5 }}
                                                            color={"error"}
                                                          >
                                                            This field is
                                                            required.
                                                          </Typography>
                                                        )}
                                                      {value !== null && (
                                                        <Typography
                                                          sx={{
                                                            textAlign: "center",
                                                            ml: 2,
                                                          }}
                                                        >
                                                          {
                                                            labels[
                                                              hoverEffect[
                                                                sectionIndex
                                                              ]?.[
                                                                categoryIndex
                                                              ]?.[questionIndex]
                                                                ?.employee_rating !==
                                                              null
                                                                ? hoverEffect[
                                                                    sectionIndex
                                                                  ]?.[
                                                                    categoryIndex
                                                                  ]?.[
                                                                    questionIndex
                                                                  ]
                                                                    ?.employee_rating
                                                                : value
                                                            ]
                                                          }
                                                        </Typography>
                                                      )}
                                                    </Box>
                                                  </Box>
                                                </Box>
                                              );
                                            }
                                          )}
                                        </Box>
                                      </Box>
                                    );
                                  }
                                )}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      );
                    })}
                  </Box>
                  {/* {edit && ( */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "right",
                      p: 1,
                      m: 1,
                    }}
                  >
                    <Button
                      id="save_button"
                      size="large"
                      variant="outlined"
                      // disabled={!allRatingsFilled}
                      onClick={(e) => {
                        handleSave(e);
                      }}
                      disabled={isSpecialCharError}
                      sx={{ m: 1 }}
                    >
                      {" "}
                      Save
                    </Button>
                    <Button
                      id="mark_for_submission_button"
                      type="submit"
                      size="large"
                      variant="contained"
                      // disabled={!allRatingsFilled}
                      disabled={isSpecialCharError}
                      sx={{ m: 1 }}
                    >
                      Mark for Submission
                    </Button>
                  </Box>
                  {/* )} */}
                </FormControl>
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default ShowResponseAppraisalForm;
